// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'boat-cargo';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M1.031 16.969a4.074 4.074 0 0 0 3.188-1.417c1.062 1.062 1.24 1.417 2.302 1.417S7.938 16.614 9 15.552c1.063 1.062 1.417 1.417 2.48 1.417s1.239-.355 2.301-1.417a4.074 4.074 0 0 0 3.188 1.417m-.262-2.161.184-1.494a.501.501 0 0 0-.1-.418.516.516 0 0 0-.396-.177H1.563a.539.539 0 0 0-.505.36.524.524 0 0 0-.027.22c.051.55.18 1.089.383 1.602' />
    <path d='M15.906 12.719h-4.25v-8.5a1.063 1.063 0 0 1 1.063-1.063h2.125a1.063 1.063 0 0 1 1.062 1.063zm-2.125-7.083h-2.125m2.657-2.48V1.031M3.156 6.698h8.5v6.02H2.094V7.762a1.062 1.062 0 0 1 1.062-1.063zm3.188 0v6.02m-4.25-3.01h9.378' />
  </g>
);

export const viewBox = '0 0 18 18';
